import {Component} from '@angular/core';
import {kanMailsService} from "../../../services/services/mails";
import {Mail} from "../../../../classes/mail";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {MailTemplate} from "../../../../classes/mailTemplate";
import {kanMailTemplatesService} from "../../../services/services/templates";
import {kanFilesService} from "../../../services/services/files";
import 'ckeditor';
import {FileLog} from "../../../../classes/fileLog";

@Component({
    selector: 'kan-mailing',
    templateUrl: './component.html',
    styleUrls: ['./component.scss']
})
export class kanMailing {

    public selectedTab: number;
    public birthdayMail: Mail;
    public renewalMail: Mail;
    public templates: MailTemplate[] = [];
    public mailForm: FormGroup;
    public renewalMailForm: FormGroup;
    private editorListener: any;

    constructor(private formBuilder: FormBuilder,
                private fileService: kanFilesService,
                private templatesService: kanMailTemplatesService,
                private mailsService: kanMailsService) {

    }

    ngOnInit(): void {

        this.mailForm = this.formBuilder.group({
            active: new FormControl(false),
            templateId: new FormControl('', [Validators.required]),
            subject: new FormControl('', [Validators.required]),
            body: new FormControl('', [Validators.required])
        });

        this.renewalMailForm = this.formBuilder.group({
            active: new FormControl(false),
            templateId: new FormControl('', [Validators.required]),
            subject: new FormControl('', [Validators.required]),
            body: new FormControl('', [Validators.required])
        });

        this.templatesService.getTemplates()
            .then((templates) => {
                this.templates = templates
            });

        this.mailsService.getBirthdayMail()
            .then((mail) => {
                this.birthdayMail = mail;
            });

        this.mailsService.getRenewalMail()
            .then((mail) => {
                this.renewalMailForm.controls.active.setValue(mail.active);
                this.renewalMailForm.controls.templateId.setValue(mail.templateId);
                this.renewalMailForm.controls.subject.setValue(mail.subject);
                this.renewalMailForm.controls.body.setValue(mail.body);

                this.renewalMail = mail;
            });

        setTimeout(() => {

            this.editorListener = CKEDITOR.on('dialogDefinition', this.onDialogDefinition.bind(this));
        }, 0);
    }

    public tabChanged(index: number): void {
        this.selectedTab = index;
    }

    private onDialogDefinition(event) {
        let that = this;
        let dialogName = event.data.name;
        let dialogDefinition = event.data.definition;

        if (dialogName == 'image') {

        }
        dialogDefinition.removeContents('Link');
        dialogDefinition.removeContents('Upload');
        dialogDefinition.removeContents('advanced');

        let infoTab = dialogDefinition.getContents('info');

        let button = infoTab.get('browse') || {};

        delete button.filebrowser;
        delete button.hidden;

        button.id = 'upload';
        button.type = 'button';
        button.label = 'subir archivo';
        button.onClick = function (ev) {
            let fileLog = new FileLog();
            fileLog.type = 'MAIL';
            let input = document.createElement('input');
            input.type = 'file';
            input.click();
            input.addEventListener('change', (e) => {
                let file = input.files[0];
                that.fileService.addFileLog(fileLog, file, file.name)
                    .then((fileLog) => {
                        this.getDialog().setValueOf('info', 'txtUrl', `https://admin.kanstak.com/files/${fileLog.file.path}`);
                    });
            });
        };
    }

    public updateMail(event) {
        this.mailsService.updateMail(this.birthdayMail)
            .then((note) => {
                this.mailsService.getBirthdayMail()
                    .then((mail) => {
                        this.birthdayMail = mail;
                    });
            })
            .catch((error) => {
                console.log(error);
            });
    }

    public updateRenewalMail(event) {
        let value = this.renewalMailForm.value;

        Object.keys(value)
            .forEach(key => this.renewalMail[key] = value[key]);

        this.mailsService.updateMail(this.renewalMail)
            .then(() => {
                this.mailsService.getRenewalMail()
                    .then((mail) => {
                        this.renewalMailForm.controls.active.setValue(mail.active);
                        this.renewalMailForm.controls.templateId.setValue(mail.templateId);
                        this.renewalMailForm.controls.subject.setValue(mail.subject);
                        this.renewalMailForm.controls.body.setValue(mail.body);

                        this.renewalMail = mail;
                    });
            })
            .catch((error) => {
                console.log(error);
            });
    }
}



// WEBPACK FOOTER //
// ./src/modules/main/components/mailing/component.ts